// An absent or malformed Core collection is not proof of an empty result.
// Throw into useCore's existing retryable error state; a valid empty array stays empty.
export function requiredCollection(data, key) {
  const collection = data?.[key];
  if (!Array.isArray(collection) || !collection.every((entry) =>
    entry !== null && typeof entry === "object" && !Array.isArray(entry))) {
    throw new Error("Unknown Core collection format");
  }
  return collection;
}
